import { render } from "./ViewAddPaymentConfirm.vue?vue&type=template&id=25bd221e"
import script from "./ViewAddPaymentConfirm.vue?vue&type=script&lang=js"
export * from "./ViewAddPaymentConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__